import styled from 'styled-components';
import LeftIcon from '../../../new-components/svg-icons/LeftIcon';
import { useTranslation } from 'next-i18next';
import { useRouter } from 'next/router';

const BackButton = () => {
  const router = useRouter();

  const handleClick = () => {
    router.back();
  };

  return (
    <BackButtonContainer locale={router.locale} onClick={handleClick}>
      <LeftIcon width="7" strokeWidth="2" stroke="#5F606A" />
    </BackButtonContainer>
  );
};

const MHeader = () => {
  const { t } = useTranslation('cityscape');

  return (
    <Container>
      <BackButton />

      <h1>{t('offers')}</h1>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px 8px 8px;
  background: #fff;

  h1 {
    color: #1a2028;
    font-size: 17px;
    font-family: materialBold;
    text-transform: capitalize;
  }
`;

const BackButtonContainer = styled.div<{ locale: string | undefined }>`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  padding: 8px 10px;
  border-radius: 360px;
  background: #edf1f6;
  transform: ${({ locale }) => (locale === 'ar' ? 'rotate(180deg)' : 'none')};
`;

export default MHeader;
